// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__piij8","loading":"Loading_loading__iPjuJ"};